<template>
  <section class="section-login">
    <div v-if="errMessage != ''" class="server-response">
      <svg class='server-response__icon'>
        <use href="../assets/sprite.svg#icon-exclamation-circle"></use>
      </svg>
      <span>{{ errMessage }}</span>
    </div>
    <div class="login">
      <div class="login__form login__form--animate">
        <form  v-show="retrievePassword === false" @submit.prevent="login()" class="form">
          <h2 class="heading-secondary">exopera 2.0</h2>
          <Entry
            typeField='email'
            indicator="login.username"
            :maskOnValue='hasToBeAnEmail'
            required
            v-model="email"
          />
          <Entry
            typeField='password'
            indicator="login.password"
            :maskOnValue='hasToBeAValidPassword'
            required
            v-model="password"
          />
          <div class="form__footer">
              <button class="btn">{{ $t('login.btn') }}</button>
              <a href="#" @click="retrievePassword = true" class="form__link">{{ $t('login.password.forgot') }}</a>
          </div>
        </form>
        <form  v-show="retrievePassword === true" @submit.prevent="askNewPassword()" class="form">
          <h2 class="heading-secondary">exopera 2.0</h2>
          <span style='font-size:1.8rem'>{{ $t('login.retrieve-password.title') }}</span>
          <span style='font-size:1.3rem;'>{{ $t('login.retrieve-password.descriptive') }}</span>
          <Entry
            typeField='email'
            indicator="login.username"
            :maskOnValue='hasToBeAnEmail'
            required
            v-model="email"
          />

          <div class="forgot-password__footer">
            <button class="popup__link u-pointer" type="button" @click='cancel'>{{ $t('login.retrieve-password.cancelAction') }}</button>
            <button class="popup__link u-pointer" type="submit">{{ $t('login.retrieve-password.confirmAction') }}</button>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import Entry from '../components/Entry'
import { formMixin } from '../components/Mixins/Form'
import { toastMixin } from '../components/Mixins/Toast'
import { HTTP_CLIENT } from '../axios-wrapper'

export default {
  data: function () {
    return {
      email: '',
      password: '',
      errMessage: '',
      retrievePassword: false
    }
  },
  components: {
    Entry
  },
  mixins: [formMixin, toastMixin],
  methods: {
    async login () {
      const { email, password } = this

      // Entry is valid
      if (email && password && !this.$el.querySelectorAll('[data-entry-not-valid]').length) {
        try {
          await this.$store.dispatch('auth/LOGIN', { email, password })
          this.errMessage = ''
          this.$router.push('dashboard')
        } catch (err) {
          if (err.response) {
            this.errMessage = err.response.data.errmsg
          }
        }
      }
    },
    async askNewPassword () {
      if (this.email) {
        try {
          await HTTP_CLIENT.post(`auth/forgot`, { email: this.email })
          this.sendSuccessToast(this.$t('feedback-ok.user.retrieve-password'))
          this.retrievePassword = false
        } catch (err) { console.log(err) }
      }
    },
    cancel () {
      this.retrievePassword = false
    }
  }
}
</script>
